module.exports = __webpack_public_path__ + "fonts/chevron-right.svg";